module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "content-title",
    attrs: {
      "id": "calibre_toc_4"
    }
  }, [_vm._v("Glad "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("to Be "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("Human")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Adventures in Optimism")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Irene O’Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal",
    attrs: {
      "id": "calibre_pb_9"
    }
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/image/MangobzLogo.png"
    }
  }), _c('br', {
    staticClass: "calibre3"
  })]), _c('span', {
    staticClass: "charoverride9"
  }, [_vm._v("Coral Gables")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45494cf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/GladtoBeHuman_split_004.vue
// module id = 72
// module chunks = 0